import { EnhancementStub } from '../../models/enhancement'
import { TrendIndicatorStats } from '../../shared/UI/TrendIndicatorCard/TrendIndicator'
import { enhancementsStatsFilter } from './enhancementSummaryFilter'

export function getStats(
  enhancements: EnhancementStub[],
  previousTotal: number,
  type: string | undefined
): TrendIndicatorStats {
  const array = type ? [type] : []
  const isOnCall = type?.toLowerCase() === 'on call'
  const currentTotal = enhancementsStatsFilter(enhancements, array).reduce(
    (total, enhancement) => {
      const value = isOnCall && enhancement.shifts ? enhancement.shifts : enhancement.hours
      return value ? total + value : total
    },
    0
  )

  let percentDiffernce
  if (!previousTotal && !currentTotal) percentDiffernce = 0
  else
    percentDiffernce =
      previousTotal === 0 ? 100 : Math.round((currentTotal / previousTotal) * 100 - 100)

  const hours = Number(Math.round(currentTotal))

  return { hours, percentage: percentDiffernce }
}
